import { ensureConfig } from "./configuration-service";

export const getLoginUrl = () => {
  const baseUrl = `${window.location.protocol}//${window.location.host}`;
  return `${baseUrl}/login/login.html`;
};

const getLogoutUrl = () => {
  const baseUrl = `${window.location.protocol}//${window.location.host}`;
  return `${baseUrl}/logout/logout.html`;
};

export const getCognitoLogoutUrl = () => {
  const config = ensureConfig();

  return `${config.CognitoUrl}/logout?client_id=${encodeURIComponent(
    config.CognitoClientId
  )}&logout_uri=${encodeURIComponent(getLogoutUrl())}`;
};
